'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createImports = createImports;
exports.addImport = addImport;
exports.insertImports = insertImports;

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

var _compilerState = require('./compilerState');

var _astLocUtils = require('ast-loc-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createImports() {
  return {};
} // import id from 'importPath'
function addImport(imports, importPath, name) {
  if (typeof importPath !== "string") return;
  if (!imports[importPath]) imports[importPath] = [];
  if (imports[importPath].indexOf(name) < 0) return imports[importPath].push(name);
}function insertImports(imports, path) {
  var useRequire = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var loc = (0, _compilerState.getCompilerState)().firstLoc;

  var stmts = function () {
    var _arr = [];for (var _i3 = 0, _keys2 = Object.keys(imports), _len3 = _keys2.length; _i3 < _len3; _i3++) {
      var _importPath = _keys2[_i3];var _importNames = imports[_importPath];
      for (var _i4 = 0, _len4 = _importNames.length; _i4 < _len4; _i4++) {
        var _name = _importNames[_i4];
        if (useRequire) {
          // const [name] = require("[path]")
          _arr.push((0, _astLocUtils.placeTreeAtLocWhenUnplaced)(_types2.default.variableDeclaration("const", [_types2.default.variableDeclarator(_types2.default.identifier(_name), _types2.default.callExpression(_types2.default.identifier("require"), [_types2.default.stringLiteral(_importPath)]))]), loc));
        } else {
          // import [name] from "[path]"
          _arr.push((0, _astLocUtils.placeTreeAtLocWhenUnplaced)(_types2.default.importDeclaration([_types2.default.importDefaultSpecifier(_types2.default.identifier(_name))], _types2.default.stringLiteral(_importPath)), loc));
        }
      }
    }return _arr;
  }();

  if (stmts.length > 0) return path.unshiftContainer("body", stmts);
}